import { batch, useDispatch, useSelector } from 'react-redux'
import { useContext } from 'react'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import NoneAnchor from 'components/NoneAnchor'
import { addFilter } from 'features/dashboard/filter/dashboardFilterSlice'
import PropTypes from 'prop-types'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'

const IdFilterMenu = ({ menu }) => {
  const dispatch = useDispatch()
  const { title, domain } = menu
  const { value, setValue, setMenuVisible } = useContext(FilterContext)
  const { filters } = useSelector(state => state.dashboard.filter)
  const filter = filters.find(
    item => item.domain === domain && item.key === 'id'
  )
  const ids = filter ? filter.data.value.split(',') : []
  if (ids.includes(value)) {
    const index = ids.indexOf(value)
    ids.splice(index, 1)
  }
  if (ids.length === 10) {
    ids.shift()
  }
  ids.push(value)
  return (
    <li>
      <NoneAnchor
        className="link_searchfilter"
        onClick={() => {
          setValue('')
          setMenuVisible(false)
          window.scrollTo({ top: 0 })
          batch(() => {
            dispatch(
              addFilter({
                domain,
                key: 'id',
                data: {
                  value: ids.join(','),
                },
              })
            )
            dispatch(campaignTableActions.setPage(0))
            dispatch(adGroupTableActions.setPage(0))
            dispatch(keywordTableActions.setPage(0))
            dispatch(creativeTableActions.setPage(0))
          })
        }}>
        {title}
        {domain === 'creativeLink' && '연결'} ID{' '}
        <em className="fc_emph">{value}</em> 일치
      </NoneAnchor>
    </li>
  )
}
IdFilterMenu.propTypes = {
  menu: PropTypes.shape({
    title: PropTypes.string,
    domain: PropTypes.string,
  }),
}
export default IdFilterMenu
